export function verdade<T>(
  data?: null | undefined | (T | null | undefined)[]
): T[] {
  return ((Array.isArray(data) ? data : []) as T[]).filter((item) => {
    return !!item;
  });
}
